
import { Modal } from 'antd';

export function jModalSuccess(
    title?: string,
    content?: string,
    handleOk?:() => void,
    className?: any,
    style?: any){
    return Modal.success({
        title: title,
        content: content,
        onOk: handleOk,
        className: className,
        style: style,
    });
}

export function jModalError(
    title?: string,
    content?: string,
    handleOk?:() => void,
    className?: any,
    style?: any) {
    return Modal.error({
        title: title,
        content: content,
        onOk: handleOk,
        className: className,
        style: style
    });
}


export function jModalWarning(
    title?: string,
    content?: string,
    handleOk?:() => void,
    className?: any,
    style?: any) {
    return Modal.warning({
        title: title,
        content: content,
        onOk: handleOk,
        className: className,
        style: style
    });
}

